import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { RouterProvider } from 'react-router-dom';

import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';

import { router } from 'src/routes/router';

import { themeConfig } from 'src/theme';

// ----------------------------------------------------------------------

// Base Emotion cache (RTL is handled separately inside ThemeProvider via
// src/theme/with-settings/right-to-left.tsx). These wrappers don't use router
// context, so they stay above RouterProvider; all other providers live inside
// the router root (src/routes/root-layout.tsx).
const emotionCache = createCache({ key: 'css' });

export default function App() {
  return (
    <CacheProvider value={emotionCache}>
      <InitColorSchemeScript
        modeStorageKey={themeConfig.modeStorageKey}
        attribute={themeConfig.cssVariables.colorSchemeSelector}
        defaultMode={themeConfig.defaultMode}
      />
      <RouterProvider router={router} />
    </CacheProvider>
  );
}
